// Unused for now — not referenced anywhere
// export const MEGA_NEWS = [
//     { c: 'महाराष्ट्र', h: 'राज्यात कांद्याच्या भावात मोठी घसरण, शेतकऱ्यांचे आंदोलन', color: '#c0392b' },
//     { c: 'राजकारण', h: 'विधानसभेत सत्तासंघर्ष: हालचालींना वेग', color: '#8B0000' },
//     { c: 'क्रीडा', h: 'रोहित शर्मा कसोटी संघातून निवृत्त', color: '#1565C0' },
//     { c: 'व्यवसाय', h: 'सेन्सेक्सने ८०,००० चा ऐतिहासिक टप्पा ओलांडला', color: '#1B5E20' },
//     { c: 'पुणे', h: 'पुण्यात मेट्रोच्या तिसऱ्या टप्प्याचे काम सुरू', color: '#E65100' },
//     { c: 'मनोरंजन', h: 'रितेश देशमुखचा नवा चित्रपट दिवाळीला प्रदर्शित', color: '#6A1B9A' },
// ];

export const COMPANY_LINKS = [
    { label: 'आमच्याबद्दल', href: `${process.env.NEXT_PUBLIC_APP_URL}company/about-us` },
    { label: 'आमचे लेखक', href: `${process.env.NEXT_PUBLIC_APP_URL}author/सुनील देशमुख` },
    { label: 'संपर्क करा', href: `${process.env.NEXT_PUBLIC_APP_URL}company/contact-us` },
    { label: '—', href: '#', divider: true },
    { label: 'संपादकीय धोरण', href: `${process.env.NEXT_PUBLIC_APP_URL}company/editorial-policy` },
    { label: 'गोपनीयता धोरण', href: `${process.env.NEXT_PUBLIC_APP_URL}company/privacy-policy` },
    { label: 'अटी व शर्ती', href: `${process.env.NEXT_PUBLIC_APP_URL}company/terms-and-conditions` },
    { label: 'कुकी धोरण', href: `${process.env.NEXT_PUBLIC_APP_URL}company/cookie-policy` },
    { label: '—', href: '#', divider: true },
    { label: 'जाहिरात द्या', href: `${process.env.NEXT_PUBLIC_APP_URL}company/advertise` },
];

// Unused for now — header social icons removed; share is only via ShareBubble
// export const SOCIAL_LINKS = [
//     {
//         label: 'WhatsApp',
//         href: process.env.NEXT_PUBLIC_SOCIAL_WHATSAPP || 'https://wa.me/',
//         icon: 'whatsapp',
//     },
//     {
//         label: 'Facebook',
//         href: process.env.NEXT_PUBLIC_SOCIAL_FACEBOOK || 'https://facebook.com/',
//         icon: 'facebook',
//     },
//     {
//         label: 'X',
//         href: process.env.NEXT_PUBLIC_SOCIAL_X || 'https://x.com/',
//         icon: 'x',
//     },
//     {
//         label: 'YouTube',
//         href: process.env.NEXT_PUBLIC_SOCIAL_YOUTUBE || 'https://youtube.com/',
//         icon: 'youtube',
//     },
// ];
